import {useFetch} from "../useFetch";
import {Schedule} from "../../types/api/planRoute/shedule.types";
import {scheduleService} from "../../services/planRoute/schedule-service";


export const useFetchScheduleByCpId = (cpId: string) => {
    const { isLoading, error, data, refetch } = useFetch<Schedule>(scheduleService.getByCpId, [cpId]);

    return { data: data as Schedule, isLoading, error, refetch };
}